/**
 * Client-supplied save/submit intent, mirrored 1:1 with the backend's
 * WorkflowStatus enum ("PE"/"CP") so no translation layer is needed at the
 * HTTP boundary. Replaces the former raw 'R'/'S' string literals.
 */
export enum SurveySubmissionStatus {
  Save = 'PE',
  Submit = 'CP'
}
